export const MobileWallet = (params) => {
  return (
    <>
      <div className='relative pt-12' key={params.header}>
        <dl>
          <dt>
            <h3 className='3xl:text-2xxl text-base font-bold leading-6 sm:text-xl lg:text-xl'>
              {params.header}
            </h3>
          </dt>
          <dd className='mt-6 object-bottom text-base font-medium sm:text-sm md:text-lg'>
            {params.description}
          </dd>
        </dl>
      </div>
    </>
  );
};
